// import 'ant-design-vue/lib/style'
// import Message from 'ant-design-vue/lib/message'
// import 'ant-design-vue/lib/message/style/css'

// Vue.prototype.$message = Message

import Vue from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd)